import React, { useEffect, useState } from "react";
import "./Feed.css";
import Tweet from "./Tweet.js";
import Post from "./Post";
import db from "./firebase";
import FlipMove from "react-flip-move";
function Feed() {

  const [posts,setposts]=useState([]);

  useEffect(()=> {
    db.collection("post").onSnapshot((snapshot)=>
    setposts(snapshot.docs.map((doc)=>doc.data()))
    );
  },[]);
  return (
    <div class="fee">
      <div className="feed-header">
        <h2> Home</h2>
      </div>
      <Tweet />
      <FlipMove>
      {posts.map(post=>(
      <Post
      key={post.text}
       displayname={post.displayname}
       username={post.username}
       verified={post.verified}
       avatar={post.avatar}
       text={post.text}
       image={post.image}
      />))}
 </FlipMove>
    </div>
  );
}

export default Feed;
